/**
* Web Service handler to retrieve and represent details about the logged in Merchant
*
* @class MerchantWS
*/
function MerchantWS (parent) {
	var self = this;

	AbstractWS.apply( self, arguments );

	self.allowResourceSelection			= ko.observable( null );
	self.merchantId						= ko.observable( null );
	self.resourceAppointmentEnabled		= ko.observable( null );

	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL = ko.computed( function () {
		if ( self.merchantId() ) {
			return '/qless/api/v1/kiosk/merchant/' + self.merchantId();
		}

		return null;
	});


	/**
	* Requests date from the API service
	*
	* @method doRequest
	* @param [Function] fCallback
	* @return none
	*/
	self.doRequest = function ( fCallback ) {
		if ( ! self.inited ) {
			self.inited = true;

			AbstractWS.prototype.doRequest.call( self, fCallback );
		}
	}


	/**
	* Reads data returned from the API service and sets properties
	*
	* @method processData
	* @param {XMLDocument} data
	* @return none
	*/
	self.processData = function ( data ) {
		var m = null;

		AbstractWS.prototype.processData.call( self, data );

		m = $( data ).find('merchant');

		if ( m ) {

			if ( m.attr('allowResourceSelection') ) {
				self.allowResourceSelection( ( m.attr('allowResourceSelection').toLowerCase() == 'true') ? true : ( m.attr('allowResourceSelection').toLowerCase() == 'false') ? false : m.attr('allowResourceSelection').toLowerCase() );
			}

			if ( m.attr('resourceAppointmentEnabled') ) {
				self.resourceAppointmentEnabled( (m.attr('resourceAppointmentEnabled').toLowerCase() == 'true') ? true : false );
			}
		}

	};

};

MerchantWS.prototype = AbstractWS.prototype;
MerchantWS.prototype.constructor = MerchantWS;
